<template>
  <el-dialog v-loading="loading.dialog" class="task_model_dialog" top="5vh" center title="任务" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="isCreate" :close-on-click-modal="false">
    <Share v-if="!isCreate" :shareInfo="{ pid: form.pid, tid: form.id, type: 'task', tabid: tabid }" />
    <el-form size="mini" ref="form" :rules="rules" :model="form" :disabled="step !== 2">
      <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="showDescribe" label="历史任务描述" prop="describe" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog" :disabled="false" :content="form.describe" @contentData="changeDescribeContent"
          :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <el-form-item v-if="showDetails" label="需求描述" prop="details" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog" :disabled="true" :content="form.details" @contentData="changeContent"
          :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <el-form-item label="PRD链接" v-if="form.p_link" :label-width="formLabelWidth" prop="p_link">
        <div @click="linkFn(form.p_link)"
          style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.p_link }}</div>
      </el-form-item>
      <el-form-item label="技术描述" v-if="form.re_details" prop="re_details" :label-width="formLabelWidth">
        <el-input type="textarea" disabled="true" :rows="6" placeholder="请输入内容" v-model="form.re_details" />
      </el-form-item>
      <el-form-item label="技术文档链接" v-if="form.link_to" :label-width="formLabelWidth" prop="link_to">
        <div @click="linkFn(form.link_to)"
          style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.link_to }}</div>
      </el-form-item>
      <el-form-item label="任务内容" prop="task_context" :label-width="formLabelWidth">
        <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.task_context">
        </el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="数据量级要求" prop="data_level_requirements" :label-width="formLabelWidth">
          <el-select filterable v-model="form.data_level_requirements" placeholder="请选择数据量级要求">
            <el-option v-for="(item, index) in allSelect.TEXTEDATALEVELREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="响应时间要求" prop="response_time" :label-width="formLabelWidth">
          <el-select filterable v-model="form.response_time" placeholder="请选择响应时间要求">
            <el-option v-for="(item, index) in allSelect.TEXTERESPONSETIMEREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]" />
          </el-select>
        </el-form-item>
        <el-form-item label="并发量要求" prop="concurrency" :label-width="formLabelWidth">
          <el-select filterable v-model="form.concurrency" placeholder="请选择并发量要求">
            <el-option v-for="(item, index) in allSelect.TEXTECONCURRENCYREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]" />
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          <el-select @change="changeDomain" filterable v-model="form.domain">
            <el-option v-for="(key, val) in allSelect.TEXTDOMAINS" :key="key" :label="key" :value="val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="涉及系统" prop="module" :label-width="formLabelWidth">
          <el-select filterable v-model="form.module" placeholder="请选择涉及系统">
            <el-option v-for="(value, key) in modules" :key="key" :label="value" :value="key" />
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="开发人员" prop="user_rd" :label-width="formLabelWidth">
          <el-select autocomplete="off" size="mini" v-model="form.user_rd" filterable placeholder="请选择开发人员">
            <el-option v-for="(key, value) in allSelect.TEXTUSERSEN" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="测试人员" prop="user_qa" :label-width="formLabelWidth">
          <el-select autocomplete="off" size="mini" v-model="form.user_qa" filterable placeholder="请选择测试人员">
            <el-option v-for="(key, value) in allSelect.TEXTUSERSEN" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="UAT人员" prop="user_uat" :label-width="formLabelWidth">
          <el-select autocomplete="off"  :disabled = "true" size="mini" v-model="form.user_uat" collapse-tags multiple filterable
            placeholder="请选择UAT人员">
            <el-option v-for="(key, value) in allSelect.TEXTUSERSEN" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item v-if="!isCreate" label="任务创建日期" prop="create_time" :label-width="formLabelWidth">
        {{ form.create_time }}
      </el-form-item>
      <!-- <el-form-item label="任务计划" :label-width="formLabelWidth" /> -->
      <div style="display: flex;">
        <el-form-item label="计划开发开始日期" prop="psdt" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.psdt" type="date" placeholder="请选择时间"
            :picker-options="pickerOptions_psdt" />
        </el-form-item>
        <el-form-item label="计划开发完成日期" prop="pedt" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.pedt" type="date" placeholder="请选择时间"
            :picker-options="pickerOptions_pedt" />
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="计划测试开始日期" prop="pstt" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.pstt" type="date" placeholder="请选择时间"
            :picker-options="pickerOptions_pstt" />
        </el-form-item>
        <el-form-item label="计划测试完成日期" prop="pett" :label-width="formLabelWidth">
          <el-date-picker disabled="true" value-format="yyyy-MM-dd" v-model="form.pett" type="date" placeholder="请选择时间" />
        </el-form-item>
      </div>
      <el-form-item label="计划上线日期" prop="plt" :label-width="formLabelWidth">
        <el-date-picker value-format="yyyy-MM-dd" v-model="form.plt" type="date" placeholder="请选择时间"
          :picker-options="pickerOptions_plt" @change="changeDate" />
      </el-form-item>
      <div v-if="!isCreate" style="display: flex;">
        <el-form-item v-if="form.status" label="当前状态" :label-width="formLabelWidth">
          <div style="text-decoration: underline;color: #409EFF;cursor: pointer;"
            @click="hideDialogVisible(allSelect.TEXTTASKSTATUSDIOLOGVISIBLE[form.status])">{{
              allSelect.TEXTTASKSTATUS[form.status]
            }}
          </div>
        </el-form-item>
        <el-form-item label="任务进度" :label-width="formLabelWidth">
          {{ (form.progress || 0) + '%' }}
        </el-form-item>
        <el-form-item label="BUG" :label-width="formLabelWidth">
          <div style="text-decoration: underline;color: #409EFF;cursor: pointer;" @click="dialog.bugVisible = true">
            {{ bugOption.new }}/{{ bugOption.count }}</div>
        </el-form-item>
      </div>
      <el-form-item v-if="!isCreate && form.taskHistory.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="form.taskHistory" />
      </el-form-item>
      <el-form :model="form" v-if="!isCreate">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment :pid='String(form.pid)' :tid="String(form.id)" type="task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
<!--      <el-button v-show="step === 1" v-if="isAdmin || (isAdmin && !isCreate && !isHistoryReviewed)" type="primary"
        @click="changeStep">
        编 辑
      </el-button>
      <el-button v-show="step === 2" v-if="isAdmin || (isAdmin && !isHistoryReviewed || isCreate)" style="margin-left:0;"
        :loading="loading.submit" type="warning" @click="onSubmit">{{ isCreate ? '创 建' : '提 交' }}</el-button>
      <el-button type="danger" v-if="!isCreate && isAdmin && !isHistoryReviewed" @click="onDelete">删 除
      </el-button>-->
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" custom-class="task_model_dialog_child" width="85%" center
      :title="'【' + form.id + '】 ' + form.module + '.' + form.domain" :visible.sync="dialog.bugVisible" append-to-body>
      <TableBug :bugOption="bugOption" />
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Comment from './comment.vue'
import {
  getDevOpsSpaceTaskDetailApi,
  postDevopsSpaceTaskUpdateApi,
  postDevOpsSpaceDeleteTaskApi,
  getListMetersphereBugsApi
} from "@/server/tops/devOps";
import { formatStrToArr } from "@/views/tops/devOps/components/util.js"
import { postDevOpsSpaceCreateTaskApi } from "../../../../../server/tops/devOps";
import { TaskHistory } from '@/views/tops/devOps/components/list'
import { TableBug } from '@/views/tops/devOps/components/table'
import Share from "./share.vue"
import { mapState } from "vuex";
export default {
  components: { Editor, Comment, TaskHistory, Share, TableBug },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    }
  },
  data() {
    return {
      form: {
        taskHistory: [], // 任务历史
        details: '', // 描述富文本内容
        domain: 'ehsy.com',
        pett: '',
        describe:''
      },
      rules: {
        title: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        module: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        user_rd: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        user_qa: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        psdt: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pedt: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pstt: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pett: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        plt: {
          // required: true,
          message: "必填",
          trigger: "blur",
        },
        domain: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        task_context: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        data_level_requirements: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        response_time: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        concurrency: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      formLabelWidth: '140px',
      step: 1, // 1. 编辑 2. 提交
      loading: {
        dialog: false
      },
      bugOption: {
        count: 0,
        resolved: 0,
        new: 0,
        closed: 0,
        bugs: []
      },
      dialog: {
        bugVisible: false
      },
      username: '',
      pickerOptions_psdt: {
        disabledDate: (time) => {
          return this.disabledDate('psdt', time)
        }
      },
      pickerOptions_pedt: {
        disabledDate: (time) => {
          return this.disabledDate('pedt', time)
        }
      },
      pickerOptions_pstt: {
        disabledDate: (time) => {
          return this.disabledDate('pstt', time)
        }
      },
      pickerOptions_plt: {
        disabledDate: (time) => {
          return this.disabledDate('plt', time)
        }
      },
      link: {
        p_link: false,
        link_to: false
      },
      showDetails: false,
      showLinkTo: false,
      showPLink: false
    };
  },
  async created() {
    const { reviewed_status = 'not_reviewed', taskInfo = {}, reviewer, is_admin, link_to, re_details, p_link,user_pm } = this.formInfo;
    const { id = '', task_progress = 0, status = '', pid = '', title = '', } = taskInfo;
    this.form = { ...this.form, id, pid, progress: task_progress, status, title, reviewed_status, reviewer, is_admin, link_to, re_details, p_link , user_uat: [user_pm]}
    this.showLinkTo = link_to;
    this.showReDetails = re_details;
    this.showPLink = p_link;
    if (id) await this.init();
    if (this.isCreate) {
      this.step = 2;
    };
    this.username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    ),
    // 是否显示编辑按钮
    showEdit() {
      if (this.isHistoryReviewed) return false;
      if (this.isCreate) return false;
      if (!this.isAdmin) return false;
      return true
    },
    modules() {
      let obj = {}
      const MODULESARR = this.allSelect.MODULESARR || [];
      MODULESARR.filter(itm => itm[2] === this.form.domain).forEach((item) => {
        obj[item[1]] = item[0];
      });
      return obj
    },
    isAdmin() {
      const { is_admin = 0, reviewer = '' } = this.form;
      const { p_status = '', space = '' } = this.formInfo?.taskInfo || {};
      if (space === 'operatorSpace' || p_status === 'p_stop' || p_status === 'p_canceled') return false;
      return is_admin || (reviewer === this.username);
    },
    // 判断是否是创建
    isCreate() {
      const { id = '', openType = '' } = this.formInfo?.taskInfo || {};
      return !id || openType === 'copy';
    },
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    }
  },
  methods: {
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    changeDomain(e) {
      delete this.form.module;
    },
    disabledDate(type, time) {
      const nowTime = Date.now() - 60 * 60 * 24 * 1000;
      const { psdt = '', pedt = '', pstt = '', pett = '', create_time = '', plt = '' } = this.form;
      switch (type) {
        case 'psdt':
          if (pedt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pedt)).getTime()
          }
          if (pstt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
          }
          if (plt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
          }
          return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000
        case 'pedt':
          if (psdt) {
            if (pstt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
            }
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'pstt':
          if (pedt) {
            if (plt) {
              return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'plt':
          if (pstt) {
            return time.getTime() <= (new Date(pstt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (pedt) {
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
      }
    },
    // 初始化页面
    async init() {
      this.queryDevOpsSpaceTaskDetail();
      this.queryListMetersphereBugs();
    },
    // 获取bug信息
    async queryListMetersphereBugs() {
      try {
        const ret = await getListMetersphereBugsApi({ tid: this.form.id })
        if (ret.status === 'success') {
          this.bugOption = {
            ...ret.count,
            count: ret.data?.length || 0,
            bugs: ret.data || []
          }
        } else {
          this.$notify({
            message: ret.message || '',
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "获取bug信息失败",
          type: "error",
        })
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceTaskDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTaskDetailApi({
          id: this.form.id || "",
          pid: this.form.pid || '',
          space: 'producerSpace',
        });
        const info = ret.data[0] || {};
        const { user, user_uat, history = '[]', psdt = '0', pedt = '0', pstt = '0', plt = '0', pett = '0', is_admin = 0, details = '', p_link = '', link_to = '', re_details = '',describe = '' } = info;
        this.form = {
          ...this.form,
          ...info,
          user: formatStrToArr(user),
          user_uat: formatStrToArr(user_uat),
          taskHistory: JSON.parse(history),
          psdt: this.$moment(psdt * 1).format("YYYY-MM-DD"),
          pedt: this.$moment(pedt * 1).format("YYYY-MM-DD"),
          pstt: this.$moment(pstt * 1).format("YYYY-MM-DD"),
          pett: this.$moment(pett * 1).format("YYYY-MM-DD"),
          plt: this.$moment(plt * 1).format("YYYY-MM-DD"),
        };
        this.showDetails = !!details;
        this.showDescribe = !!describe;
        this.showLinkTo = this.showLinkTo ? true : link_to;
        this.showReDetails = this.showReDetails ? true : re_details;
        this.showPLink = this.showPLink ? true : p_link;
      } catch (error) {
        this.$notify({
          message: error || "获取任务详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    // 任务创建及更新
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const { id, pid, title = '', task_context = '', link_to = '', re_details = '', p_link = '', data_level_requirements = '', response_time = '', concurrency = '', details = '', describe = '',user_rd = [], user_qa = [], user_uat = [], module = '', psdt, pedt, pett, pstt, plt, domain } = this.form;
          const params = {
            space: "producerSpace",
            user_rd: user_rd.toString(),
            user_qa: user_qa.toString(),
            user_uat: user_uat.toString(),
            psdt: Date.parse(psdt),
            pedt: Date.parse(pedt + ' 23:59:59'),
            pstt: Date.parse(pstt),
            pett: Date.parse(pett + ' 23:59:59'),
            plt: Date.parse(plt + ' 23:59:59'),
            module,
            title,
            details,
            describe,
            domain,
            link_to,
            re_details,
            p_link,
            task_context,
            data_level_requirements,
            response_time,
            concurrency
          }

          if (!this.isCreate) { // 更新
            params.project_url = pid;
            params.id = id;
          } else { // 创建
            params.id = pid;
          }
          try {
            this.$set(this.loading, 'submit', true)
            const ret = !this.isCreate ? await postDevopsSpaceTaskUpdateApi(params) : await postDevOpsSpaceCreateTaskApi(params);
            this.$notify({
              message: ret?.data?.msg || "数据异常",
              type: ret.status === 'success' ? 'success' : "error",
            })
            ret.status === 'success' && this.hideDialogVisible();
          } catch (error) {
            this.$notify({
              message: error || "数据异常",
              type: "error",
            })
          } finally {
            this.loading.submit = false;
          }
        }
      })
    },
    // 格式化 props
    formatFormInfo(val) {
      if (val) {
        return val.split(',')
      }
      return []
    },
    changeDate() {
      this.$nextTick(() => {
        this.form.pett = this.form.plt
      })
    },
    // 关闭弹窗
    handleClose() {
      this.hideDialogVisible()
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.details = val;
    },
    changeDescribeContent(val){
      this.form.describe = val;
    },
    // 任务删除
    onDelete() {
      this.$confirm("此操作将删除该需求, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'delete', true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: this.form.id,
          });
          if (res.status === "success") {
            this.$notify({
              message: "删除成功",
              type: "success",
            })
            this.handleClose();
          } else {
            this.$notify({
              message: res.data.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.delete = false;
        }
      });
    },
    // 从编辑到提交 1 -> 2
    changeStep() {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$set(this, 'step', 2)
      })
    },
  }
};
</script>
<style lang="scss">
.task_model_dialog {

  .el-form-item__label {
    font-weight: bold;
  }

  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
}
</style>